<script>
  import { onMount } from "svelte";

  export let openScopes
  export let openNewApp

  let apps = {}

  onMount(async () => {
    console.log("ACL Apps")
    apps = await window.api.authorization.apps.query();
  });
</script>

<div class="container-xl">
  <div class="row">
    <div class="col-md-6">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title">ACL Apps</h3>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <table>
              <tbody>
                {#each Object.entries(apps) as [index, app]}
                  <tr>
                    <td>
                      <a href="#x" onclick={() => openScopes(app.id)}>{app.name}</a>
                    </td>
                  </tr>
                {/each}
              </tbody>
            </table>
          </div>
        </div>

        <div class="card-footer text-end">
          <button type="submit" class="btn btn-primary" onclick={() => openNewApp()}>New</button>
        </div>
      </div>
    </div>
  </div>
</div>